<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

const props = defineProps({
  value: { type: String, default: '' },
  isPrivate: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'apply']);

const { t } = useI18n();

const draft = ref(props.value);
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-[10001] grid p-4 place-items-center bg-n-alpha-black1 backdrop-blur-[2px]"
      @pointerdown.stop
    >
      <div
        class="flex flex-col w-full max-w-2xl max-h-full overflow-hidden rounded-xl bg-n-background shadow-xl outline outline-1 outline-n-container"
      >
        <div
          class="flex items-center justify-between gap-4 px-6 py-4 border-b border-n-weak"
        >
          <h2 class="mb-0 text-lg font-medium text-n-slate-12">
            {{ t('AUTOMATION.FLOW.MESSAGE.TITLE') }}
          </h2>
          <Button
            icon="i-lucide-x"
            color="slate"
            variant="ghost"
            size="sm"
            @click="emit('close')"
          />
        </div>

        <div class="flex flex-col flex-1 gap-3 px-6 py-4 overflow-y-auto">
          <WootMessageEditor
            v-model="draft"
            class="px-3 py-2 rounded-lg bg-n-alpha-1 outline outline-1 outline-n-weak dark:outline-n-strong"
            :placeholder="t('AUTOMATION.FLOW.MESSAGE.PLACEHOLDER')"
            :enable-suggestions="false"
            :is-private="isPrivate"
            enable-variables
            enable-canned-responses
          />
          <p v-if="!isPrivate" class="mb-0 text-xs text-n-slate-11">
            {{ t('AUTOMATION.FLOW.MESSAGE.HINT') }}
          </p>
        </div>

        <div
          class="flex items-center justify-end gap-2 px-6 py-4 border-t border-n-weak"
        >
          <Button
            :label="t('AUTOMATION.FLOW.MESSAGE.CANCEL')"
            color="slate"
            variant="faded"
            @click="emit('close')"
          />
          <Button
            :label="t('AUTOMATION.FLOW.MESSAGE.APPLY')"
            @click="emit('apply', draft)"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>
